import { memo } from 'react';
import { AlertTriangle, CalendarClock, Minus } from 'lucide-react';
import { KanbanClassOfService, CLASS_OF_SERVICE_CONFIG } from '../../types/kanban';
import { cn } from '../../utils/cn';

interface Props {
  classOfService: KanbanClassOfService;
  className?: string;
  showLabel?: boolean;
}

export const KanbanClassOfServiceIndicator = memo(
  ({ classOfService, className, showLabel = false }: Props) => {
    if (classOfService === 'standard') return null;
    const config = CLASS_OF_SERVICE_CONFIG[classOfService];
    const Icon =
      classOfService === 'expedite'
        ? AlertTriangle
        : classOfService === 'fixed_date'
          ? CalendarClock
          : Minus;
    return (
      <span
        className={cn('badge border', className)}
        style={{
          backgroundColor: `${config.color}20`,
          borderColor: `${config.color}40`,
          color: config.color,
        }}
        title={config.label}
      >
        <Icon className="w-3 h-3" />
        {showLabel && config.label}
      </span>
    );
  },
);
KanbanClassOfServiceIndicator.displayName = 'KanbanClassOfServiceIndicator';
